import { Inject, Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { InsectaServiceBase } from '../insecta.base.service';
import { IDeliveryDay, IDeliveryUnavailableDate } from '../insecta.models';
import { DictionaryCacheService } from '../dictionary-cache.service';
import { HttpClient } from '@angular/common/http';
import { SETTINGS, Settings } from '../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class DeliveryDayAdminService extends InsectaServiceBase {
  constructor(
    private http: HttpClient,
    @Inject(SETTINGS) settings: Settings,
    private dictionaryCache: DictionaryCacheService
  ) {
    super(http, settings);
  }
  public addUnavailableDate(locationId: string, date: any): Observable<string> {
    return this.post<string>(`/admin/sites/${locationId}/delivery/dates/${date}`, `v1`, {}).pipe(
      tap(() => this.dictionaryCache.invalidate('UndeliverableDates'))
    );
  }

  public getDeliveryDays(locationId: string): Observable<IDeliveryDay[]> {
    return this.get<IDeliveryDay[]>(`/admin/sites/${locationId}/delivery/days`, 'v1').pipe(
      map((results) => [...results].sort((a, b) => (a.dayId > b.dayId ? 1 : -1)))
    );
  }

  public getUnavailableDatesByRange(locationId: string, lower: any, upper: any): Observable<IDeliveryUnavailableDate[]> {
    return this.get<IDeliveryUnavailableDate[]>(`/admin/sites/${locationId}/delivery/dates/${lower}/${upper}`, 'v1').pipe(
      map((results) => [...results].sort((a, b) => (a.date > b.date ? 1 : -1)))
    );
  }

  public getUnavailableDatesByRangeForAll(
    locationId: string,
    lower: any,
    upper: any,
    includeInactive: boolean
  ): Observable<IDeliveryUnavailableDate[]> {
    return this.get<IDeliveryUnavailableDate[]>(`/admin/sites/${locationId}/delivery/dates/${lower}/${upper}/${includeInactive}`, 'v1').pipe(
      map((results) => [...results].sort((a, b) => (a.date > b.date ? 1 : -1)))
    );
  }

  public updateDeliveryDay(locationId: string, day: 0 | 1 | 2 | 3 | 4 | 5 | 6, status: boolean): Observable<any> {
    return this.patch(`/admin/sites/${locationId}/delivery/days/${day}/${status}`, `v1`, {}).pipe(
      tap(() => this.dictionaryCache.invalidate('UndeliverableDays'))
    );
  }

  public updateUnavailableDate(locationId: string, date: any, status: boolean): Observable<any> {
    return this.patch(`/admin/sites/${locationId}/delivery/dates/${date}/${status}`, `v1`, {}).pipe(
      tap(() => this.dictionaryCache.invalidate('UndeliverableDates'))
    );
  }
}
